import React from "react";
import Typewriter from "typewriter-effect";
import { Button, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaGithub, FaLinkedinIn, FaMediumM } from "react-icons/fa";
import { HiOutlineArrowRight, HiOutlineMail } from "react-icons/hi";
import "./Header.css";
import Home2 from "./Home.js";
import profileImage from "./profile.jpeg";
import { heroStats, profile } from "../data/portfolio";

const Header = () => {
  return (
    <section>
      <Container fluid className="home-section section-shell" id="home">
        <Container className="home-content">
          <Row className="align-items-center g-5">
            <Col lg={7} className="home-header reveal-up">
              <div className="eyebrow-pill">Open to frontend & mobile engineering roles</div>
              <h1 className="hero-title">
                I build web and mobile products that feel <span className="hero-accent">instant</span>.
              </h1>
              <div className="hero-type">
                <Typewriter
                  options={{
                    strings: [
                      "Frontend & React Native Engineer",
                      "Web performance specialist",
                      "E-commerce & checkout engineer",
                      "Shipping from idea to production",
                    ],
                    autoStart: true,
                    loop: true,
                    deleteSpeed: 35,
                  }}
                />
              </div>
              <p className="hero-copy">
                I'm {profile.name}, an engineer based in {profile.location}. I spend my days making high-traffic
                e-commerce faster — snappier storefronts, smoother mobile apps, checkouts that convert — and building
                the tooling that lets teams ship with confidence.
              </p>
              <div className="cta-row hero-actions">
                <Button as={Link} to="/projects" variant="primary">
                  View work <HiOutlineArrowRight />
                </Button>
                <Button as={Link} to="/resume" variant="outline-light">
                  Resume
                </Button>
              </div>
              <div className="hero-socials" aria-label="Professional links">
                <a href={profile.github} target="_blank" rel="noreferrer" aria-label="GitHub">
                  <FaGithub />
                </a>
                <a href={profile.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn">
                  <FaLinkedinIn />
                </a>
                <a href={profile.medium} target="_blank" rel="noreferrer" aria-label="Medium">
                  <FaMediumM />
                </a>
                <a href={`mailto:${profile.email}`} aria-label="Email">
                  <HiOutlineMail />
                </a>
              </div>
            </Col>

            <Col lg={5} className="reveal-up delay-2">
              <div className="hero-card glass-panel">
                <div className="hero-photo-wrap">
                  <img src={profileImage} alt="Sagnik Pal" className="hero-photo" />
                </div>
                <div className="hero-card-body">
                  <p className="hero-card-kicker">Current focus</p>
                  <h2>Web performance, polished mobile apps, and checkouts that convert.</h2>
                  <div className="hero-stack">
                    {["React", "React Native", "SvelteKit", "TypeScript", "AWS", "Jest", "Playwright"].map(
                      (item) => (
                        <span key={item}>{item}</span>
                      )
                    )}
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          <Row className="hero-stats reveal-up delay-3">
            {heroStats.map((stat) => (
              <Col md={3} sm={6} key={stat.label}>
                <div className="stat-card scroll-reveal">
                  <strong>{stat.value}</strong>
                  <span>{stat.label}</span>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </Container>
      <Home2 />
    </section>
  );
};

export default Header;
